import React from "react"

export const LoadingStatValue = ({ className = "h-8 w-10" }) => (
  <span className={`inline-block animate-pulse-soft rounded-lg bg-gray-100 ${className}`} />
)

export const LoadingScoreValue = () => (
  <span className="mx-auto inline-block h-6 w-8 animate-pulse-soft rounded bg-gray-200" />
)

export default LoadingStatValue
